import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { Cookie } from "lucide-react";

const KEY = "ag_cookie_seen_v1";

export default function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        // Sanftes verzögertes Einblenden — nicht aufdringlich
        const id = setTimeout(() => setShow(true), 800);
        return () => clearTimeout(id);
      }
    } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] ag-fade-in-up"
      role="region"
      aria-label={t.cookie.aria}
    >
      <div className="ag-card p-5 shadow-lg border-slate-200 bg-white/95 backdrop-blur">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center shrink-0">
            <Cookie className="h-4 w-4 text-slate-600" strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-serif text-lg text-ag-ink mb-1">{t.cookie.title}</div>
            <p className="text-sm text-slate-600 leading-relaxed">{t.cookie.body}</p>
            <div className="flex items-center gap-3 mt-3">
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="px-4 h-9 rounded-lg bg-ag-ink hover:bg-slate-800 text-white text-sm transition-colors"
              >
                {t.cookie.accept}
              </button>
              <Link
                to="/datenschutz"
                data-testid="cookie-learn-more"
                className="text-xs text-slate-500 hover:text-ag-ink underline-offset-4 hover:underline"
              >
                {t.cookie.learnMore}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
